import { useEffect } from "react";

const OG_IMAGE = "https://images.unsplash.com/photo-1583165278997-0250ea5d72e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxlc3ByZXNzbyUyMG1hY2hpbmUlMjBtb2Rlcm4lMjBvZmZpY2UlMjBzcGVjaWFsdHklMjBjb2ZmZWV8ZW58MHx8fHwxNzkyMjIxMDAyfDA&ixlib=rb-4.1.0&q=85";

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta(title, description) {
  useEffect(() => {
    if (!title) return;
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description || "");
    setMeta("property", "og:image", OG_IMAGE);
  }, [title, description]);
}
